// Session JWT temp user (tunnel SEA) : persistance cookie (multi-onglets) + hydratation Pinia.

import type { UserProfileDto } from '~/types/AccountProfile'
import { useFrontApi } from '~/composables/useFrontApi'
import { useUserStore } from '~/stores/user'
import { authCookies } from '~/utils/authCookies'

/**
 * Gestion de la session temp user : jeton `temp_session` et profil via `GET /api/Profile/me`.
 */
export class TempUserSession {
  private constructor() {}

  /**
   * Restaure le JWT temp user en Pinia si absent (appelé par `getApiToken()`).
   * @returns {void}
   */
  static restoreTokenToStore(): void {
    if (!import.meta.client) return

    const userStore = useUserStore()
    if (userStore.token) return

    const token: string | null = authCookies.getTempToken()
    if (token === null || token === '') return

    userStore.setAccessToken(token)
  }

  /**
   * Si un jeton temp est présent, synchronise le profil via `GET /api/Profile/me`.
   * @param {string | null} fallbackEmail - E-mail MSAL si l'API ne le renvoie pas.
   * @returns {Promise<boolean>} `true` si l'utilisateur est connecté après synchronisation.
   */
  static async syncProfileFromMe(fallbackEmail: string | null): Promise<boolean> {
    if (!import.meta.client) return false

    this.restoreTokenToStore()

    const userStore = useUserStore()
    const token: string | null = userStore.token
    if (token === null || token === '') return userStore.isLoggedIn

    try {
      const { data } = await useFrontApi().get<UserProfileDto>('/api/Profile/me')
      const apiUserId: string = data.id?.trim() ?? ''

      if (!userStore.isLoggedIn && apiUserId !== '') {
        userStore.login({
          userId: apiUserId,
          firstName: data.firstName?.trim() || 'Étudiant',
          avatar: null,
          mbti: null,
          profileCompletion: 0,
          token,
        })
      }

      userStore.setProfilFromMe(data, fallbackEmail)
    } catch (err: unknown) {
      // Jeton invalide : on nettoie pour ne pas rediriger à tort en SSR.
      const status: number | undefined = (err as { response?: { status?: number } } | null)
        ?.response?.status
      if (status === 401 || status === 403) {
        authCookies.clearTempToken()
        userStore.logout()
      }
    }

    return userStore.isLoggedIn
  }
}
